import { ReactComponent as Icon } from "components/common/Icons/Progress/Pie/NoneGray/icon.svg";
interface Props {}

const NoneGray = (_: Props) => {
  return <Icon />;
};

export default NoneGray;
